export const usersFrag = `
    id
    name
    surname
    titleBeforeName
    titleAfterName
`;
